<template>
    <v-layout column fill-height>
        <v-card class="mb-1">
            <v-toolbar elevation="0" dense>
                <v-row dense>
                    <v-tabs height="2em" color="info" show-arrows class="d-flex align-center">
                        <v-tab :to="{ name: 'ProposalsDashboard' }" class="flex-shrink-1">
                            <v-icon left>{{ icons.mdiViewColumn }}</v-icon>
                            {{ $t("enums.Routes.ProposalsDashboard") }}
                        </v-tab>
                        <v-tab :to="{ name: 'ActivitiesDashboard' }" class="flex-shrink-1">
                            <v-icon left>{{ icons.mdiViewColumn }}</v-icon>
                            {{ $t("enums.Routes.ActivitiesDashboard") }}
                        </v-tab>
                        <v-tab :to="{ name: 'Statistics' }" class="flex-shrink-1">
                            <v-icon left>{{ icons.mdiChartBar }}</v-icon>
                            {{ $t("enums.Routes.Statistics") }}
                        </v-tab>
                    </v-tabs>
                </v-row>
            </v-toolbar>
        </v-card>
        <v-fade-transition mode="out-in">
            <router-view style="overflow-y:auto" />
        </v-fade-transition>
    </v-layout>
</template>

<script>
import { mdiViewColumn, mdiChartBar } from "@mdi/js"

export default {
    name: "KanbanDashboard",
    data() {
        return {
            icons: {
                mdiViewColumn, mdiChartBar
            }
        }
    }

}
</script>

<style scoped lang="scss"></style>